module.exports = __webpack_public_path__ + "static/lato-latin-300.ad990910.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-300.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-300.woff
// module chunks = 17241999800008180000